import { PhxContextService, PhxButtonSize, PHOENIX_CONTEXTS, Ellipses } from 'phx-core';

import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, HostListener, Optional, SkipSelf } from '@angular/core';

import { AdminFeatureFlagService } from '@app/services/feature-flags/admin';
import { isMobileView } from '@app/lib/screen-sizes';

export interface IKebabMenuOption {
  isOptionDivider?: boolean;
  label: string;
  labelType?: KEBAB_MENU_LABEL_TYPES;
  key: string;
  isDisabled?: boolean;
  isHidden?: boolean;
}

export enum KEBAB_MENU_LABEL_TYPES {
  DANGER = 'danger',
}

@Component({
  selector: 'phx-kebab-menu',
  templateUrl: './phx-kebab-menu.component.html',
  styleUrls: ['./phx-kebab-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-kebab-menu',
    '[class.phx-filter]': `phxStyleType === '${PHOENIX_CONTEXTS.FILTER}'`,
  },
})
export class PhxKebabMenuComponent {
  @Input() public menuOptions: IKebabMenuOption[] = [];
  @Input() public hideOnClick: boolean = true;
  @Input() public isVisible: boolean = false;
  @Input() public isDisabled: boolean = false;
  @Input() public height: number = 24;
  @Input() public width: number = 36;
  @Input() public iconSize: PhxButtonSize;

  public labelType: typeof KEBAB_MENU_LABEL_TYPES = KEBAB_MENU_LABEL_TYPES;

  public readonly experimentalImplementation: boolean;
  public readonly ellipsesIcon: string = Ellipses;
  public isMobileView: boolean = isMobileView();
  public phxStyleType: PHOENIX_CONTEXTS;

  @Output() public readonly toggleDropdown = new EventEmitter<boolean>();
  @Output() public readonly onOptionSelection = new EventEmitter<IKebabMenuOption>();

  private isDropdownOpen: boolean;

  constructor(
    private adminFeatureFlagService: AdminFeatureFlagService,
    @Optional() @SkipSelf() contextService: PhxContextService,
  ) {
    this.experimentalImplementation = this.adminFeatureFlagService.isGroupFilterInNewHeaderEnabled();
    this.phxStyleType = contextService?.getType();
  }

  public onToggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.toggleDropdown.emit(this.isDropdownOpen);
  }

  public onOptionSelect(selectedValue: IKebabMenuOption): void {
    if (selectedValue.isDisabled) return;
    this.onOptionSelection.emit(selectedValue);
  }

  @HostListener('window:resize')
  private onResize(): void {
    this.isMobileView = isMobileView();
  }
}
